export interface MaterialPriceType {
    id: number;
    name: string;
    priority: number;
}
